import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CoreService, DialogService, FileService, SaveFormEvent, SpinnerService } from 'dspx-core';
import { API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES, VERSIONS } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { FileSaverService } from 'ngx-filesaver';
import { take } from 'rxjs';

@Component({
  selector: 'app-concessions-application-bulk-upload-detail',
  templateUrl: './concessions-application-bulk-upload-detail.component.html',
  styleUrl: './concessions-application-bulk-upload-detail.component.scss'
})

export class ConcessionsApplicationBulkUploadDetailComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {
  fieldTypeReplacements = OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.concessionsApplicationBulkUploadDetail;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  userHasConcessionsTeamRole: boolean;
  showGenerateLinkingCode: boolean;
  showBankDetailsButton: boolean;

  private documentManagementServiceFileId: string = '';
  private nameOfFile: string = '';
  private formIdentifierAndEntityId: string = '';


  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,
    private fileService: FileService,
    private fileSaverService: FileSaverService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        if (id) {
          this.id = id;
          this.formServiceEndpoint = API_ENDPOINT_KEYS.getConcessionsApplicationBulkUploadDetailConfigAndResponse;
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions = {
    };

    this.coreService.applicationFunctions = {
      home: () => this.home(),
      downloadFileBtn: () => this.downloadFileBtn()
    };
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {
    this.documentManagementServiceFileId = event.documentManagementServiceFileId;
    this.nameOfFile = event.nameOfFile;
    this.formIdentifierAndEntityId = event.formIdentifierAndEntityId;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
  }

  cancel(event: any) {
  }

  private home(): void {
    this.navigate(['/', ROUTE_CONSTANTS.concessionsApplicationBulkUploadList.list]);
  }

  private downloadFileBtn() {
    this.fileService.download(this.formIdentifierAndEntityId, this.documentManagementServiceFileId)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const dispositionHeader = response.headers.get('content-disposition');
          if (!dispositionHeader) {
            throw new Error('content-disposition header is not found');
          }
          this.fileSaverService.save(response.body, this.nameOfFile);
        },
        error: (error: any) => {
          console.log('Bulk Upload File download error: ', error);
        },
        complete: () => {
          console.log('Bulk Upload File download completed');
        },
      });
  }

  dialogButton_Clicked(event: any): void {
    this.reloadPage(true);
  }
}
